import { ListInstanceMethods as DataTreeInstanceMethods } from '@infotech-soe/erp-ui-kit';
import { TDatabaseId } from '@infotech-soe/metaschema';
import { Ref, useEffect, useMemo, useRef } from 'react';

import { CategoryTreeStateEntity } from '../../../models/category/categoryTree';

const findActiveIndex = (treeState: CategoryTreeStateEntity | undefined) => {
  if (!treeState) return -1;
  const { activeId, nodes } = treeState;
  if (activeId === null) {
    return -1;
  }
  return nodes.findIndex(node => node.id === activeId);
};

export const useTree = (
  treeState: CategoryTreeStateEntity | undefined
): {
  activeIndex: number;
  handle: Ref<DataTreeInstanceMethods<TDatabaseId>>;
} => {
  const handle = useRef<DataTreeInstanceMethods<TDatabaseId> | null>(null);
  const activeIndex = useMemo(() => findActiveIndex(treeState), [treeState]);

  const activeId = treeState?.activeId ?? null;

  useEffect(() => {
    if (handle.current !== null && activeId !== null) {
      handle.current.scrollToNodeById(activeId);
    }
  }, [activeId]);

  return { activeIndex, handle };
};
